function hashString(value) {
  let hash = 2166136261;
  const input = String(value || '');
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

function seededRandom(seed) {
  let state = seed >>> 0;
  return () => {
    state += 0x6D2B79F5;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function orderStimuliForParticipant(stimuli, randomization, seedParts = []) {
  const indexed = (Array.isArray(stimuli) ? stimuli : []).map((stimulus, originalIndex) => ({
    ...stimulus,
    __originalIndex: originalIndex,
  }));

  const shouldShuffle = randomization === 'per-participant-shuffle' || randomization === 'shuffle';
  if (!shouldShuffle || indexed.length < 2) {
    return indexed.map((stimulus, displayIndex) => ({ ...stimulus, __displayIndex: displayIndex }));
  }

  const random = seededRandom(hashString(seedParts.filter(Boolean).join('|')));
  const shuffled = [...indexed];
  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled.map((stimulus, displayIndex) => ({ ...stimulus, __displayIndex: displayIndex }));
}

export function resolveMediaUrl(rawUrl, apiRoot) {
  if (!rawUrl || typeof rawUrl !== 'string') return '';
  if (/^https?:\/\//i.test(rawUrl)) return rawUrl;
  return `${apiRoot}${rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`}`;
}